var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E91"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E91",
    className: "cls-2",
    points: "233 218 233 342 182 342 182 309 62 309 62 228 132 228 132 218 233 218"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E90"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E90",
    className: "cls-2",
    points: "179 312 179 345 200 345 200 371 179 371 179 407 62 407 62 312 179 312"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E89"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E89",
    className: "cls-2",
    points: "233 375 233 503 132 503 132 490 62 490 62 410 182 409 182 375 233 375"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E88"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E88",
    className: "cls-2",
    points: "337 382 337 490 236 490 236 375 312 375 312 382 337 382"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E87"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E87",
    className: "cls-2",
    points: "340 382 365 382 365 375 441 375 441 490 340 490 340 382"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "E86"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E86",
    className: "cls-2",
    points: "546 382 546 490 445 490 445 375 521 375 521 382 546 382"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "E85"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E85",
    className: "cls-2",
    points: "650 375 650 490 549 490 549 382 573 382 573 375 650 375"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "E84"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E84",
    className: "cls-2",
    points: "754 382 754 490 653 490 653 375 729 375 729 382 754 382"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "E83"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E83",
    className: "cls-2",
    points: "789 360 888 360 888 490 858 490 858 503 757 503 757 375 789 375 789 360"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "E82"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E82",
    className: "cls-2",
    points: "888 228 888 357 789 357 789 342 757 342 757 218 858 218 858 228 888 228"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "E81"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E81",
    className: "cls-2",
    x: 653,
    y: 228,
    width: 101,
    height: 114
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "E80"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E80",
    className: "cls-2",
    x: 578,
    y: 228,
    width: 72,
    height: 114
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "E93"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E93",
    className: "cls-2",
    x: 340,
    y: 228,
    width: 124,
    height: 114
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "E92"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E92",
    className: "cls-2",
    x: 236,
    y: 228,
    width: 101,
    height: 114
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP6 as ReactComponent };